"use client";

import { useState } from "react";
import { ServiceContactModal } from "@/components/services/ServiceContactModal";

/**
 * 간편/무료 상담 버튼 — 클릭 시 기존 ServiceContactModal(문의 폼)을 연다.
 * className으로 버튼 스타일을 자유롭게 지정.
 */
export function ConsultButton({
  className,
  children,
  ariaLabel,
}: {
  className?: string;
  children: React.ReactNode;
  ariaLabel?: string;
}) {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        aria-label={ariaLabel}
        className={className}
        onClick={() => setOpen(true)}
      >
        {children}
      </button>
      <ServiceContactModal isOpen={open} onClose={() => setOpen(false)} />
    </>
  );
}
